import { useContext } from 'react';
import { ManageKeysContext } from './ManageKeysProvider';

export const useManageKeys = () => {
  const context = useContext(ManageKeysContext);
  if (!context) {
    throw new Error('useManageKeys must be used within ManageKeysProvider');
  }
  return context;
};
